import React from 'react';
import { useT } from '../../i18n/LanguageContext';
import strings from './PrivacyPolicyPage.i18n';
import './LegalPage.css';

export default function PrivacyPolicyPage() {
  const t = useT(strings);
  return (
    <div className="legal-page">
      <section className="legal-hero">
        <div className="section" style={{ textAlign: 'center' }}>
          <p className="section-label">{t.sectionLabel}</p>
          <h1 className="section-title">{t.title}</h1>
          <p className="section-subtitle" style={{ margin: '0 auto' }}>
            {t.subtitle}
          </p>
          <p className="legal-updated">{t.lastUpdated}</p>
        </div>
      </section>

      <section className="legal-content section">
        <div className="legal-section">
          <h2>{t.s1Title}</h2>
          <p>{t.s1p1}</p>
          <p>{t.s1p2}</p>
        </div>

        <div className="legal-section">
          <h2>{t.s2Title}</h2>
          <h3>{t.s2h1}</h3>
          <p>{t.s2p1}</p>
          <ul>
            {t.s2l1.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
          <h3>{t.s2h2}</h3>
          <p>{t.s2p2}</p>
          <ul>
            {t.s2l2.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        </div>

        <div className="legal-section">
          <h2>{t.s3Title}</h2>
          <p>{t.s3p1}</p>
          <ul>
            {t.s3l1.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        </div>

        <div className="legal-section">
          <h2>{t.s4Title}</h2>
          <p>{t.s4p1}</p>
          <p>{t.s4p2}</p>
          <ul>
            {t.s4l1.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        </div>

        <div className="legal-section">
          <h2>{t.s5Title}</h2>
          <p>{t.s5p1}</p>
        </div>

        <div className="legal-section">
          <h2>{t.s6Title}</h2>
          <p>{t.s6p1}</p>
        </div>

        <div className="legal-section">
          <h2>{t.s7Title}</h2>
          <p>{t.s7p1}</p>
        </div>

        <div className="legal-section">
          <h2>{t.s8Title}</h2>
          <p>{t.s8p1}</p>
          <h3>{t.s8h1}</h3>
          <p>{t.s8p2}</p>
          <ul>
            {t.s8l1.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
          <h3>{t.s8h2}</h3>
          <p>{t.s8p3}</p>
          <h3>{t.s8h3}</h3>
          <p>{t.s8p4}</p>
          <h3>{t.s8h4}</h3>
          <p>{t.s8p5}</p>
          <h3>{t.s8h5}</h3>
          <p>{t.s8p6}</p>
        </div>

        <div className="legal-section">
          <h2>{t.s9Title}</h2>
          <p>{t.s9p1}</p>
          <ul>
            {t.s9l1.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
          <p>{t.s9p2}</p>
        </div>

        <div className="legal-section">
          <h2>{t.s10Title}</h2>
          <p>{t.s10p1}</p>
        </div>

        <div className="legal-section">
          <h2>{t.s11Title}</h2>
          <p>{t.s11p1}</p>
        </div>

        <div className="legal-section">
          <h2>{t.s12Title}</h2>
          <p>{t.s12p1}</p>
        </div>

        <div className="legal-section">
          <h2>{t.s13Title}</h2>
          <p>{t.s13p1}</p>
          <p>noreply@mampuai.com</p>
          <p>63-4B, Tingkat 4, Jalan Anggerik Vanilla T 31/T, Kota Kemuning, 40460 Shah Alam, Selangor</p>
        </div>
      </section>
    </div>
  );
}
